import { render, staticRenderFns } from "./Designation.vue?vue&type=template&id=a5c26888&scoped=true&"
import script from "./Designation.vue?vue&type=script&lang=js&"
export * from "./Designation.vue?vue&type=script&lang=js&"
import style0 from "./Designation.vue?vue&type=style&index=0&id=a5c26888&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c26888",
  null
  
)

export default component.exports